import { render } from "./PageTopButton.vue?vue&type=template&id=9d10bb38"
import script from "./PageTopButton.vue?vue&type=script&lang=js"
export * from "./PageTopButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__